<mat-icon *ngIf="matIcon">{{ matIcon }}</mat-icon> <ng-content></ng-content>
